import { http, httpgst } from '../../main'
import { store } from '../../store'

// initial state
const state = {}

// getters
const getters = {}

// actions
const actions = {
  get_expenses ({ commit, dispatch }, payload) {
    let url = 'api/expenses/' + payload.event.user.id + '/4'
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options)
      .then(
        response => {
          commit('expensesGet', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  get_userlogged ({ commit, dispatch }, payload) {
    let url = 'api/user-logged'
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.defaults.headers.common['X-device'] = 'WEB'
    http.get(url, {}, options)
      .then(
        response => {
          commit('userLogged', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  }
}

// mutations
const mutations = {
  expensesGet (state, payload) {
    payload.event.context.expenses = payload.response.data.data
    payload.event.context.loadingItems = false
  },
  userLogged (state, payload) {
    payload.event.context.userloggeds = payload.response.data.data
  },
  onError (state, payload) {
    if (payload.error.response.status === 401) {
      payload.event.context.showNotification(payload.event.context.$t('login.sessionExpired'), 'error', -1)
      setTimeout(() => { payload.event.context.$router.push({ name: 'LoginPage' }) }, 2000)
    } else {
      payload.event.context.showNotification(payload.error.response, 'error', -1)
    }
    payload.event.context.loadingItems = false
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.expensesApproved.js